import React from 'react';
import PropTypes from 'prop-types';
/* eslint-disable react/no-unknown-property, react/self-closing-comp, react/no-unused-prop-types */
export default function HistoryIcon({ className = 'h-4 w-4', strokeWidth = 2 }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8'></path>
      <path d='M3 3v5h5'></path>
      <path d='M12 7v5l4 2'></path>
    </svg>
  );
}

HistoryIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};
